import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';

import {COLORS} from 'config/constants';
import {formatHSCode} from 'utils/helpers';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';
import PreferencesSelect from './components/preferencesSelect/index';
import PreferencesText from './components/preferencesText';

import './preferences-choose.scss';

const PreferencesChoose = ({code, handleChangePreferences}: CustomsPreferencesChooseProps) => {
  const {t, i18n} = useTranslation();

  return (
    <div className='preferences' lang={i18n.resolvedLanguage}>
      <Typography variant='subtitle1' sx={{
        fontWeight: 500,
        color: COLORS.BLACK_DARK,
        lineHeight: '24px',
      }}>
        {formatDemoCopy(`${t('calc__text__customs__preferencesForTheHSCode')} ${formatHSCode(code)}`)}
      </Typography>
      <PreferencesText />
      <PreferencesSelect handleChangePreferences={handleChangePreferences} />
    </div>
  );
};

export default PreferencesChoose;
